class Header {
    constructor() {}
    init() {
        this.header = document.querySelector('.mn-hdr');
        this.hdrLogo = document.querySelector('.hdr-logo');
        this.heroLogo = document.querySelector('.hero-logo');
        this.triggerElement = document.querySelector('.jdl-btn, .jdl-rentals-btn');
        this.classToAdd = this.header.getAttribute('data-scrolled-class');
        this.scrollAmount = 220;
        this.startOffset = 0;

        if (!this.header || !this.header.classList.contains('_overlay')) {
            console.log('No header element or overlay class');
            return;
        }

        if (!this.classToAdd) {
            console.log('No data-scrolled-class value');
            return;
        }

        if (this.triggerElement) {
            this.startOffset = this.triggerElement.getBoundingClientRect().top + this.triggerElement.offsetHeight;
        }

        this.updateHeader();

        window.addEventListener('scroll', () => {
            this.updateHeader();
        });
        window.addEventListener('resize', () => {
            this.updateHeader();
        });
    }
    destroy() {
        window.removeEventListener('scroll', () => {
            this.updateHeader();
        });
        window.removeEventListener('resize', () => {
            this.updateHeader();
        });

        this.resetElements();
    }
    updateHeader() {
        if (this.header.classList.contains('_overlay')) {
            const scrollY = window.scrollY;

            if (scrollY > this.startOffset) {
                if (window.innerWidth >= 1024) {
                    if (scrollY > (this.scrollAmount * (this.header.classList.contains('_hide-logo') ? 2 : 1))) {
                        this.header.classList.add(this.classToAdd);
                    } else {
                        this.header.classList.remove(this.classToAdd);
                    }
                }
            }

            if (this.header.classList.contains('hide-logo')) {
                if (scrollY > this.startOffset) {
                    if (this.hdrLogo || this.heroLogo) {
                        // Opacity calculations for fading elements
                        const fadeAmount = Math.min(1, Math.max(0, (scrollY - this.startOffset) / this.scrollAmount));

                        if (this.hdrLogo) {
                            this.hdrLogo.style.opacity = fadeAmount;
                        }
                        if (this.heroLogo) {
                            this.heroLogo.style.opacity = 1 - (fadeAmount * 1.4);
                        }
                    }
                }
                else {
                    if (this.hdrLogo) {
                        this.hdrLogo.style.opacity = 0;
                    }
                    if (this.heroLogo) {
                        this.heroLogo.style.opacity = 1;
                    }
                }
            }
        }
    }
    resetElements() {
        // Ensure opacity is reset if scrolling too fast back to the top
        if (this.hdrLogo) {
            this.hdrLogo.removeAttribute('style');
        }
        if (this.heroLogo) {
            this.heroLogo.removeAttribute('style');
        }
    }
}

export default new Header();
